import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "pk10 loseinfo"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "冠亚军和", -1);

const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "冠亚军和-两面", -1);

const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "theme-border-half",
  style: {
    "padding": "3px 7px",
    "margin-top": "3px",
    "border": "1px solid"
  }
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 总投注额： ");

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 最高亏损： ");

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 最高盈利： ");

const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "冠军", -1);

const _hoisted_17 = ["onClick"];
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];

const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "亚军", -1);

const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];

const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第三名", -1);

const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];

const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第四名", -1);

const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];

const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第五名", -1);

const _hoisted_37 = ["onClick"];
const _hoisted_38 = ["onClick"];
const _hoisted_39 = ["onClick"];
const _hoisted_40 = ["onClick"];

const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第六名", -1);

const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["onClick"];

const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第七名", -1);

const _hoisted_47 = ["onClick"];
const _hoisted_48 = ["onClick"];
const _hoisted_49 = ["onClick"];
const _hoisted_50 = ["onClick"];

const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第八名", -1);

const _hoisted_52 = ["onClick"];
const _hoisted_53 = ["onClick"];
const _hoisted_54 = ["onClick"];
const _hoisted_55 = ["onClick"];

const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第九名", -1);

const _hoisted_57 = ["onClick"];
const _hoisted_58 = ["onClick"];
const _hoisted_59 = ["onClick"];
const _hoisted_60 = ["onClick"];

const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "第十名", -1);

const _hoisted_62 = ["onClick"];
const _hoisted_63 = ["onClick"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = ["onClick"];
const _hoisted_66 = {
  class: "title theme-border-half light-bg"
};

const _hoisted_67 = /*#__PURE__*/_createTextVNode(" 总额： ");

const _hoisted_68 = {
  class: "theme-text"
};
const _hoisted_69 = {
  class: "theme-text num"
};

const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", {
  class: "title theme-border-half light-bg"
}, "两面长龙", -1);

const _hoisted_71 = /*#__PURE__*/_createTextVNode("暂无数据");

const _hoisted_72 = {
  class: "theme-text num"
};
const _hoisted_73 = {
  ref: "pl_popver",
  class: "pl_popver"
};
const _hoisted_74 = {
  class: "pl_popver_title"
};
const _hoisted_75 = {
  style: {
    "text-align": "center"
  }
};

const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 赔率： ");

const _hoisted_77 = {
  style: {
    "margin": "10px",
    "text-align": "center"
  }
};

const _hoisted_78 = /*#__PURE__*/_createTextVNode("  取消  ");

const _hoisted_79 = /*#__PURE__*/_createTextVNode("  确认  ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_col = _resolveComponent("el-col");

  const _component_el_row = _resolveComponent("el-row");

  const _component_el_divider = _resolveComponent("el-divider");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    gutter: 2
  }, {
    default: _withCtx(() => [$props.title == '冠、亚军 组合' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_2, _createVNode(_component_el_table, {
        data: $data.gyjh,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_4), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_6)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_7, _createVNode(_component_el_table, {
        data: $data.gyjh_lm,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_9), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_11)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createElementVNode("div", _hoisted_12, [_createElementVNode("p", null, [_hoisted_13, _createElementVNode("span", null, _toDisplayString($props.sum.all_balance), 1)]), _createElementVNode("p", null, [_hoisted_14, _createElementVNode("span", null, _toDisplayString($data.max_ks), 1)]), _createElementVNode("p", null, [_hoisted_15, _createElementVNode("span", null, _toDisplayString($data.max_yl), 1)])])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_16, _createVNode(_component_el_table, {
        data: $data.gj,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_17)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_18), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_19)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_20)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_21, _createVNode(_component_el_table, {
        data: $data.yj,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_22)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_23), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_24)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_25)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    })], 64)) : _createCommentVNode("", true), $props.title == '三、四、伍、六名' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_26, _createVNode(_component_el_table, {
        data: $data.d3,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_27)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_28), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_29)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_30)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_31, _createVNode(_component_el_table, {
        data: $data.d4,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_32)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_33), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_34)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_35)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_36, _createVNode(_component_el_table, {
        data: $data.d5,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_37)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_38), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_39)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_40)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_41, _createVNode(_component_el_table, {
        data: $data.d6,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_42)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_43), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_44)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_45)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    })], 64)) : _createCommentVNode("", true), $props.title == '七、八、九、十名' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_46, _createVNode(_component_el_table, {
        data: $data.d7,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_47)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_48), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_49)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_50)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_51, _createVNode(_component_el_table, {
        data: $data.d8,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_52)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_53), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_54)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_55)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_56, _createVNode(_component_el_table, {
        data: $data.d9,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_57)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_58), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_59)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_60)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 5
    }, {
      default: _withCtx(() => [_hoisted_61, _createVNode(_component_el_table, {
        data: $data.d10,
        border: "",
        size: "small",
        "highlight-current-row": "",
        "header-cell-class-name": "table-header-cell",
        "header-row-class-name": "table-header-row",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          property: "name",
          label: "号码",
          align: "center",
          width: "40"
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "赔率",
          align: "center"
        }, {
          default: _withCtx(scope => [_ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "plus",
            onClick: $event => $options.show_pl_popver(scope.row, 'plus')
          }, null, 8, _hoisted_62)) : _createCommentVNode("", true), _createElementVNode("span", {
            class: "item-pl",
            onClick: $event => $options.show_pl_popver(scope.row, $event)
          }, _toDisplayString(scope.row.pl), 9, _hoisted_63), _ctx.$store.state.userinfo.group_id < 5 && _ctx.$store.state.userinfo.trader_status == 1 ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "minus",
            onClick: $event => $options.show_pl_popver(scope.row, 'minus')
          }, null, 8, _hoisted_64)) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "注额",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: {
              "cursor": "pointer"
            },
            onClick: $event => $options.get_zdmx_data(scope.row)
          }, _toDisplayString(scope.row.szsz_amount[1]), 9, _hoisted_65)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          property: "title",
          label: "盈亏",
          align: "center"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", {
            style: _normalizeStyle({
              color: scope.row.szsz_amount[4] < 0 ? '#f56c6c' : '#333'
            })
          }, _toDisplayString(scope.row.szsz_amount[4]), 5)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]),
      _: 1
    })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_col, {
      span: 2
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_hoisted_67, _createElementVNode("span", _hoisted_68, _toDisplayString($props.sum.all_balance), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sum.sums, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "cl-item theme-border-half light-bg",
          key: item.index
        }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("span", _hoisted_69, _toDisplayString(item.all_balance), 1)]);
      }), 128))]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 2
    }, {
      default: _withCtx(() => [_hoisted_70, $props.chang_long.length == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_71], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList($props.chang_long, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "cl-item theme-border-half light-bg",
          key: item.index
        }, [_createTextVNode(_toDisplayString(item.title) + "-" + _toDisplayString(item.name) + " ", 1), _createElementVNode("span", _hoisted_72, _toDisplayString(item.b_s_qnum) + "期", 1)]);
      }), 128))]),
      _: 1
    })]),
    _: 1
  }), _withDirectives(_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, "修改赔率:" + _toDisplayString($data.pl_popver.row.name), 1), _createElementVNode("div", null, [_createVNode(_component_el_divider, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.pl_popver.value), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_75, [_hoisted_76, _createVNode(_component_el_input, {
    style: {
      "width": "80px"
    },
    modelValue: $data.pl_popver.pl_change_value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pl_popver.pl_change_value = $event),
    size: "small",
    min: "0"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_77, [_createVNode(_component_el_button, {
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $data.pl_popver.show = false)
  }, {
    default: _withCtx(() => [_hoisted_78]),
    _: 1
  }), _createVNode(_component_el_button, {
    type: "primary",
    size: "small",
    onClick: $options.sub_change_pl
  }, {
    default: _withCtx(() => [_hoisted_79]),
    _: 1
  }, 8, ["onClick"])])], 512), [[_vShow, $data.pl_popver.show]])]);
}